export default __webpack_public_path__ + "static/media/fw-madelyn-er-White Gold.bbfdb929.mp4";